import { render } from "./select.vue?vue&type=template&id=f1aaabc2&scoped=true&ts=true"
import script from "./select.vue?vue&type=script&lang=ts"
export * from "./select.vue?vue&type=script&lang=ts"

import "./select.vue?vue&type=style&index=0&id=f1aaabc2&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1aaabc2"]])

export default __exports__